function Offer() {
    return (
        <div>
            
        </div>
    )
}

export default Offer
